import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The HubSpot connector can link contacts, companies, deals, emails, meetings, quotes, and tickets to PostHog.`}</p>
    <p>{`To link Hubspot:`}</p>
    <ol>
      <li parentName="ol">{`Go to the `}<a parentName="li" {...{
          "href": "https://us.posthog.com/pipeline/sources"
        }}>{`Data pipeline page`}</a>{` and the sources tab in PostHog`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`New source`}</strong>{` and select Hubspot`}</li>
      <li parentName="ol">{`Select the Hubspot account you want to link and click `}<strong parentName="li">{`Connect app`}</strong></li>
      <li parentName="ol"><em parentName="li">{`Optional:`}</em>{` Add a prefix to your table names`}</li>
      <li parentName="ol">{`Select the tables you want to import (incremental/append syncs are not supported for HubSpot tables.)`}</li>
      <li parentName="ol">{`Click `}<strong parentName="li">{`Import`}</strong></li>
    </ol>
    <p>{`The data warehouse then starts syncing your Hubspot data. You can see details, progress, and rows synced in the `}<a parentName="p" {...{
        "href": "https://us.posthog.com/pipeline/sources"
      }}>{`data pipeline sources tab`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      